export default "__VITE_ASSET__CzyNOKET__"